import { useState, useEffect } from 'react';

export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState<boolean>(() => typeof window !== 'undefined' && window.innerWidth < 768);
  
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768); // Standard breakpoint for mobile
    };
    
    checkIsMobile(); // Check on initial load
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);
  
  return isMobile;
};

export const getButtonClasses = (isMobile: boolean, baseClasses: string) => {
  if (isMobile) {
    return `${baseClasses} btn-touch-friendly`;
  }
  return baseClasses;
};

export const getIconButtonClasses = (isMobile: boolean, baseClasses: string) => {
  if (isMobile) {
    return `${baseClasses} icon-btn-touch-friendly`;
  }
  return baseClasses;
};

export const getPaginationButtonClasses = (isMobile: boolean, baseClasses: string) => {
  if (isMobile) {
    return `${baseClasses} pagination-btn-touch-friendly`;
  }
  return baseClasses;
};
